import { render, staticRenderFns } from "./shopAccountManage.vue?vue&type=template&id=63784b23&scoped=true"
import script from "./shopAccountManage.vue?vue&type=script&lang=js"
export * from "./shopAccountManage.vue?vue&type=script&lang=js"
import style0 from "./shopAccountManage.vue?vue&type=style&index=0&id=63784b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63784b23",
  null
  
)

export default component.exports